import lrModifyuser from './_src/lrModifyuser2.vue'
lrModifyuser.install = function(Vue) {
  Vue.component(lrModifyuser.name, lrModifyuser)
}
export default lrModifyuser